import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetSalesInvoiceListMutation, useGetSalesInvoiceCountQuery } from '../../../../store/api/salesinvoice';
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import ExportCSV from '../../../../Core/Export/ExportCSV';
import ListFilters from "../../../../Core/ListFilters/ListFilters";

import { useDeleteDocMutation } from "../../../../store/api/globalapi";
import DelConfirmPopup from "../../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../../utils/useScreenHeight";

const Lpntable = () => {
    const navigate = useNavigate();
    const { screenHeight, screenScaling, pageSize } = useScreenHeight();

    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [salesInvoice, setSalesInvoice] = useState({ sales_invoices: [], total_no_of_records: 0 });
    const [getSalesInvoiceList] = useGetSalesInvoiceListMutation();
    const { data: salesInvoiceCount , isLoading, refetch: refetchSalesInvoiceCount } = useGetSalesInvoiceCountQuery();
    const [showExportPopup, setShowExportPopup] = useState(false);
    const [showColumnConfig, setShowColumnConfig] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [deleteDoc] = useDeleteDocMutation();


    const filtersConfig = [
        { name: 'siNo', label: 'S. No.', width: '6%', type: 'number' },
        { name: 'sales_invoice_id', label: 'Sales Invoice No', width: '15%', type: 'text' },
        { name: 'customer', label: 'Customer', width: '15%', type: 'text' },
        { name: 'no_of_lines', label: 'No. of Lines', type: 'number', width: '12%' },
        { name: 'total_qty', label: 'Total Quantity', type: 'number', width: '12%' },
        {
            name: 'status',
            label: 'Status',
            width: '13.7%',
            type: 'select',
            options: [
                { value: 'Unpaid', label: 'Unpaid' },
                { value: 'Draft', label: 'Draft' },
                { value: 'Overdue', label: 'Overdue' },
                { value: 'Return', label: 'Return' },
                { value: 'To Deliver and Bill', label: 'To Deliver and Bill' },
                { value: 'Pick List Created', label: 'Pick List Created' },
                { value: 'To Bill', label: 'To Bill' },
                { value: 'Completely Picked', label: 'Completely Picked' },
                { value: 'Cancelled', label: 'Cancelled' },
                { value: 'Closed', label: 'Closed' },
            ]
        },
        { name: 'date_range', label: 'Date Range', type: 'date-range', width: '12%' },
        { name: 'taxable_amount', label: 'Taxable Amount', type: 'number', width: '12%' },
        { name: 'total_value', label: 'Total Value', type: 'number', width: '12%' },
        { name: 'gst_amount', label: 'GST Amount', type: 'number', width: '12%' },
        { name: 'sales_order', label: 'Sales Order', type: 'text', width: '15%' },
        { name: 'delivery_note', label: 'Delivery Note', type: 'text', width: '15%' },
        { name: 'created_by', label: 'Created By', type: 'text', width: '12%' },
        { name: 'updated_by', label: 'Updated By', type: 'text', width: '12%' },
        { name: 'billing_address', label: 'Billing Address', type: 'text', width: '18%' },
        { name: 'shipping_address', label: 'Shipping Address', type: 'text', width: '18%' }
    ];


    const [columnsConfig, setColumnsConfig] = useState(() => [
        {
            header: "S. No.",
            name: "S. No.",
            accessor: "siNo",
            width: '6%',
            cellRenderer: (row)=> row.siNo,
            sortable: false,
            visible: true
        },
        {
            header: "Sales Invoice No",
            name: "Sales Invoice No",
            accessor: "id",
            width: '15%',
            sortable: true,
            visible: true
        },
        {
            header: "Customer",
            name: "Customer",
            accessor: "customer",
            width: '15%',
            sortable: true,
            visible: true
        },
            {
            header: "Total Qty",
            name: "Total Qty",
            accessor: "total_qty",
            width: '12%',
            sortable: true,
            visible: true,
            sortFn: (a, b) => parseFloat(a.total_qty) - parseFloat(b.total_qty)
        },
        {
            header: "No. of Lines",
            name: "No. of Lines",
            accessor: "no_of_lines",
            width: '12%',
            sortable: true,
            visible: true,
            sortFn: (a, b) => parseInt(a.no_of_lines) - parseInt(b.no_of_lines)
        },
        {
            header: "Taxable Amount",
            name: "Taxable Amount",
            accessor: "taxable_amount",
            width: '12%',
            sortable: true,
            visible: true,
            sortFn: (a, b) => parseFloat(a.taxable_amount) - parseFloat(b.taxable_amount)
        },
        {
            header: "Total Value",
            name: "Total Value",
            accessor: "total_value",
            width: '12%',
            sortable: true,
            visible: true,
            sortFn: (a, b) => parseFloat(a.total_value) - parseFloat(b.total_value)
        },
        {
            header: "GST Amount",
            name: "GST Amount",
            accessor: "gst_amount",
            width: '12%',
            sortable: true,
            visible: false,
            sortFn: (a, b) => parseFloat(a.gst_amount) - parseFloat(b.gst_amount)
        },
        {
            header: "Sales Order",
            name: "Sales Order",
            accessor: "sales_order",
            width: '15%',
            sortable: true,
            visible: false
        },
        {
            header: "Delivery Note",
            name: "Delivery Note",
            accessor: "delivery_note",
            width: '15%',
            sortable: true,
            visible: false
        },
        {
            header: "Created By",
            name: "Created By",
            accessor: "created_by",
            width: '12%',
            sortable: true,
            visible: false
        },
        {
            header: "Updated By",
            name: "Updated By",
            accessor: "updated_by",
            width: '12%',
            sortable: true,
            visible: false
        },
        {
            header: "Billing Address",
            name: "Billing Address",
            accessor: "billing_address",
            width: '18%',
            sortable: true,
            visible: false
        },
        {
            header: "Shipping Address",
            name: "Shipping Address",
            accessor: "shipping_address",
            width: '18%',
            sortable: true,
            visible: false
        },
        {
            header: "Date",
            name: "Date",
            accessor: "date",
            width: '10%',
            sortable: true,
            visible: true,
            sortFn: (a, b) => new Date(a.date) - new Date(b.date)
        },
        {
            header: "Status",
            name: "Status",
            accessor: "status",
            width: '13%',
            sortable: true,
            visible: true,
            cellRenderer: (row) => {
                const status = row.status;
                let color;
                switch (status) {
                    case 'Unpaid': color = '#F97316'; break;
                    case 'Draft': color = '#6366F1'; break;
                    case 'Overdue': color = '#F97316'; break;
                    case 'To Deliver and Bill': color = '#6B21A8'; break;
                    case 'Pick List Created': color = '#0E7490'; break;
                    case 'To Bill': color = '#D97706'; break;
                    case 'Completely Picked': color = '#65A30D'; break;
                    case 'Cancelled': color = '#EF4444'; break;
                    case 'Closed': color = '#E11D48'; break;
                    default: color = '#000000';
                }
                return (
                    <span
                        style={{
                            backgroundColor: `${color}1A`,
                            color,
                            padding: '4px 10px',
                            borderRadius: '9999px',
                            fontSize: '12px',
                            fontWeight: 500,
                            display: 'inline-block',
                            textTransform: 'capitalize',
                        }}
                    >
                        {status}
                    </span>
                );
            }
        },
    
        {
            header: "Action",
            name: "Action",
            width: '10%',
            sortable: false,
            visible: true,
            accessor: "action",
            cellRenderer: (row) => (
                <ActionButtonDropdown
                    id={row.id}
                    onView={() => handleView(row.id)}
                    onEdit={() => handleEdit(row.id)}
                    onDelete={() => handleDelete(row.id)}
                />
            )
        }
    ]);


    const handleSaveColumns = (selectedKeys) => {
        const updatedColumns = columnsConfig.map(column => ({
            ...column,
            visible: selectedKeys.includes(column.accessor)
        }));
        setColumnsConfig(updatedColumns);
    };

    const visibleColumns = useMemo(() =>
        columnsConfig.filter(col => col.visible), [columnsConfig]);

    const defaultSelectedColumns = useMemo(() =>
        columnsConfig
            .filter(col => col.visible)
            .map(col => ({
                fieldname: col.accessor,
                label: col.name
            })), [columnsConfig]);

    const handleView = (id) => navigate(`/outbound/outbound/view-sales-invoice/`, { state: { sales_invoice_id: id } });
    const handleEdit = (id) => navigate(`/outbound/outbound/edit-sales-invoice/`, { state: { sales_invoice_id: id } });
    const [delPopupVisible, setDelPopupVisible] = useState(false);
    const [delSelectedId, setDelSelectedId] = useState(null);
    const [delmessage, setDelmessage] = useState();
    const [alreadySubmitData, setAlreadySubmitData] = useState(false)
    const [delDone, setDelDone] = useState(false)

    const handleDelete = (id) => {
        setDelSelectedId(id);
        setDelPopupVisible(true)
        setAlreadySubmitData(false)
        setDelmessage("Are you sure you want to Delete this Sales Invoice?");
    };

    const delHandleCancel = () => {
        setDelPopupVisible(false);
        setDelSelectedId(null);
    }

    const delHandleConfirm = async () => {
        
        try {
            await deleteDoc({ doctype: "Sales Invoice", name: delSelectedId }).unwrap()
            setDelmessage(`Sales Invoice ${delSelectedId} deleted successfully!`)
            setDelDone(true)
            setTimeout(() => {
                setDelPopupVisible(false);
                setDelDone(false)
                getData();
            }, 1000);
        } catch (err) {
            console.error("Deletion Failed:", err)

            let errorMessage = "Failed to delete the Sales Invoice!";

            //If the server is sending the error message , we will extract it.
            if (err?.data?._server_messages) {
                try {
                    const messageArr = JSON.parse(err.data._server_messages)
                    if (messageArr && messageArr.length > 0) {
                        //parse inner json object
                        const messageObj = JSON.parse(messageArr[0])
                        if (messageObj?.message) {
                            //extract the exact message we want
                            const fullMessage = messageObj.message
                            errorMessage = fullMessage.split('You must')[0].trim();
                            //remove html in the message
                            errorMessage = errorMessage.replace(/<[^>]+>/g, '');

                        }
                    }
                } catch (parseError) {
                    console.error("Error parsing server messages:", parseError);
                }
            }
            setDelPopupVisible(true)
            setDelmessage(errorMessage)
            setAlreadySubmitData(true);
        } finally {
            // setTimeout(() => {
            //     setDelPopupVisible(false);
            //     setDelSelectedId(null);
            // }, 2000);
        }
    };
    const activeFilterCount = useMemo(() => {
        return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
    }, [filters]);
    const actionButtons = [
        {
           className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "IoFilterSharp",
            iconSize: 12,
            children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
            onClick: () => {
                setShowFilters(prev => !prev);
                setShowColumnConfig(false);
            }
        },
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "MdOutlineRemoveRedEye",
            iconSize: 12,
            children: "Show more",
            onClick: () => {
                setShowColumnConfig(prev => !prev);
                setShowFilters(false);
            }
        },
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "RiFileExcel2Fill",
            iconSize: 12,
            children: "Export Excel",
            onClick: () => setShowExportPopup(true),
        },
        {
            className: "custom-btn-00989 d-flex",
			to: "/outbound/outbound/create-sales-invoice/",
			iconName: "FiPlus",
			style: { gap: "2px", height: "28px" },
			children: "Create Sales Invoice",
        }
    ];

    const parseDateRange = (range) => {
        if (typeof range === "string" && range.includes(" to ")) {
            const [start, end] = range.split(" to ");
            return [start.trim(), end.trim()];
        }
        return ["", ""];
    };

    const getData = async () => {

        // Add safety check
        if (pageSize <= 0) {
            console.warn('getData called with invalid pageSize:', pageSize);
            return;
        }
        setLoading(true);
        try {
					const filteredSearchInput = Object.entries(filters).reduce(
						(acc, [key, value]) => {
							if (value !== "" && value !== undefined && value !== null) {
								acc[key] = value;
							}
							return acc;
						},
						{}
					);
					const siNoFilter = filteredSearchInput.siNo;
					const isSiNoFilterActive =
						siNoFilter !== undefined && siNoFilter !== "";
					// STEP 3: If filtering by siNo, jump to that page
					const targetPage = isSiNoFilterActive
						? Math.ceil(parseInt(siNoFilter, 10) / pageSize)
						: currentPage;
					const payload = {
						start: pageSize * (targetPage - 1),
						page_length: pageSize,
						...(Object.keys(filteredSearchInput).length > 0 && {
							search_input: {
								sales_invoice_id: filteredSearchInput.sales_invoice_id || "",
								customer: filteredSearchInput.customer || "",
								status: filteredSearchInput.status || "",
								date_range: parseDateRange(filteredSearchInput.date_range),
								min_total_qty: filteredSearchInput.total_qty || 0,
								max_total_qty: filteredSearchInput.total_qty || 0,
								min_no_of_line: filteredSearchInput.no_of_lines || 0,
								max_no_of_line: filteredSearchInput.no_of_lines || 0,
							},
						}),
					};

					const response = await getSalesInvoiceList(payload).unwrap();
					const rawData = response?.message?.data || [];
					// STEP 4: Assign global serial numbers
					const numberedData = rawData.map((item, index) => ({
						...item,
						siNo: index + 1 + pageSize * (targetPage - 1),
					}));

					// STEP 5: If siNo is used, filter client-side
					const finalData = isSiNoFilterActive
						? numberedData.filter(
								(item) => item.siNo === parseInt(siNoFilter, 10)
						  )
                : numberedData;
            
					setSalesInvoice({
						sales_invoices: finalData || [],
						total_no_of_records: finalData.length,
					});
            if (isSiNoFilterActive) setCurrentPage(targetPage);
				} catch (error) {
            console.error("Error fetching sales invoices:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleFilterChange = (newFilters) => {
        setCurrentPage(1);
        setFilters(newFilters);
    };

    useEffect(() => {
        console.log('Effect triggered with pageSize:', pageSize);
        if ( pageSize > 0) {
            getData();
            refetchSalesInvoiceCount();
        }
    }, [currentPage, filters, pageSize,screenHeight,screenScaling]);





    const accessors = columnsConfig
			.filter(
				(column) => column.accessor !== "siNo" && column.accessor !== "action"
			)
			.map((column) => column.accessor);
    return (
        <div className="container-fluid d-flex flex-column" style={{ flexGrow: '1' }}>
            <Tabs />
            <ListLayout
                breadcrumbItems={[
                    { label: "Outbound" },
                    { label: "Sales Invoice List", style: { color: '#270B79' } }
                ]}
                actionButtons={actionButtons}
            >
                {showFilters && (
                    <ListFilters
                        filtersConfig={filtersConfig}
                        onFilterChange={handleFilterChange}
                        currentFilters={filters}
                        setShowFilters={setShowFilters}
                    />
                )}

                {showColumnConfig && (
                    <ConfigureColumnsNew
                        show={showColumnConfig}
                        onClose={() => setShowColumnConfig(false)}
                        onSave={handleSaveColumns}
                        docType="Sales Invoice"
                        defaultSelected={defaultSelectedColumns}
                        fieldsData={columnsConfig.map(col => ({
                            fieldname: col.accessor,
                            label: col.name
                        }))}
                        disabledFields={["siNo", "id","customer","status","date", "action"]}
                    />
                )}

                <Table
                    columns={visibleColumns}
                    data={salesInvoice.sales_invoices}
                    loading={loading}
                />

                <Pagination
                    setCurrentPage={setCurrentPage}
                    pageSize={pageSize}
                    totalRecords={salesInvoiceCount?.message}
                    currentPage={currentPage}
                    className="mt-2 pb-3"
                />
                {delPopupVisible &&
                    <DelConfirmPopup
                        alredysubmitdata={alreadySubmitData}
                        delSelectedId={delSelectedId}
                        visible={delPopupVisible}
                        message={delmessage}
                        onConfirm={delHandleConfirm}
                        onCancel={delHandleCancel}
                        delDone={delDone}
                    />}
                {showExportPopup && (
                    <ExportCSV
                        doctype="Sales Invoice"
                        fieldsData={accessors}
                        onClose={() => setShowExportPopup(false)}
                    />
                )}
            </ListLayout>
        </div>
    );
};

export default Lpntable;